function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect, useState } from 'react';
import { Table, Button, Card, Row, Col, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Loading } from '@rd-web-markets/shared/dist/util';
import { useSelector } from 'react-redux';
import { helpPages } from './Help';
import TeachingBubble from '@rd-web-markets/shared/dist/util/TeachingBubble';
import ClaimStateAlerts from '@rd-web-markets/shared/dist/claim/ClaimStateAlerts';
import { ChangeHighlighter } from '@rd-web-markets/shared/dist/util/ChangeHighlighter';
export const TotalCostsSection = _ref => {
  let {
    claim,
    saveClaim,
    setClaim,
    totalPayrollCostInvalid
  } = _ref;
  const user = useSelector(state => state.auth.user);
  const [estimated, setEstimated] = useState(false);
  const [dirty, setDirty] = useState(false);
  useEffect(() => {
    setEstimated(claim.loss_surrendered_for_tax_credits !== null && (!claim.is_long_claim_period || claim.loss_surrendered_for_tax_credits_2nd_ct !== null));
  }, [claim]);
  if (!user || !claim) return /*#__PURE__*/React.createElement(Loading, null);
  const financialsComplete = claim.completed_percent_financial[user.account_type] > 96;
  const handleChange = e => {
    setClaim(_objectSpread(_objectSpread({}, claim), {}, {
      [e.target.name]: e.target.value
    }));
  };
  const currencyFormatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2
  });
  const percentageFormatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(ClaimStateAlerts, {
    claim: claim
  }), /*#__PURE__*/React.createElement("div", {
    className: "text-end mb-2"
  }, /*#__PURE__*/React.createElement(TeachingBubble, {
    pages: helpPages,
    position: "left"
  })), /*#__PURE__*/React.createElement("div", {
    className: "pb-3"
  }), /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Header, {
    className: "bg-secondary text-primary"
  }, "Qualifying R&D expenditure"), /*#__PURE__*/React.createElement(Table, {
    striped: true
  }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, "Wages costs (note 1)"), /*#__PURE__*/React.createElement("td", {
    className: "text-end"
  }, "$ ", currencyFormatter.format(claim.employee_qualifying_rnd_expenditure))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, "Contractors (note 2)"), /*#__PURE__*/React.createElement("td", {
    className: "text-end"
  }, "$ ", currencyFormatter.format(claim.contractor_qre_totals)))))), /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Header, {
    className: "bg-secondary text-primary"
  }, "Notes 1 - Wages"), /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: Form.Control,
    onChange: handleChange,
    onBlur: () => saveClaim(claim),
    disabled: claim.financials_locked,
    object: claim,
    name: "staffing_notes",
    controlAs: "textarea",
    rows: "10"
  })), /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Header, {
    className: "bg-secondary text-primary"
  }, "Notes 2 - Contractors"), /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: Form.Control,
    onChange: handleChange,
    onBlur: () => saveClaim(claim),
    disabled: claim.financials_locked,
    object: claim,
    name: "subcontracting_notes",
    controlAs: "textarea",
    rows: "10"
  })), /*#__PURE__*/React.createElement(Row, {
    className: "pt-5 pb-5"
  }, /*#__PURE__*/React.createElement(Col, {
    className: "text-center"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    size: "lg",
    disabled: !financialsComplete,
    onClick: () => window.open("/api/claims/".concat(claim.id, "/download_financial_report.json?detailed=false"))
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "download"), " Download Report"), financialsComplete ? null : /*#__PURE__*/React.createElement("div", {
    className: "text-muted p-1"
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "info"), " Report cannot be downloaded because financials are incomplete.")))), /*#__PURE__*/React.createElement(Card.Footer, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 12,
    className: "text-start"
  }, /*#__PURE__*/React.createElement(Button, {
    as: Link,
    variant: "light",
    to: "/".concat(user.account_type, "/claims/").concat(claim.id, "/financial_details/calculations")
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "chevron_left"), " Back")))));
};